<form *ngIf='form as form' [formGroup]='form' autocomplete='off' novalidate>
  <fieldset>
    <div class='row'>
      <div class='col-12'>
        <legend>{{ label }}</legend>
      </div>
    </div>
    <br>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"startDate" as controlName'>
          <label [for]='controlName'>
            Data od *
          </label>
          <app-date-picker (change)="form.startDateChange($event)" [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"endDate" as controlName'>
          <label [for]='controlName'>
            Data do *
          </label>
          <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
          </app-date-picker>
          <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"dayQuantity" as controlName'>
          <label [for]='controlName'>
            Ilość dni
          </label>
          <input
            readonly
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Ilość dni'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <br>
    <app-exposed-map-control [control]="form.geometry">
    </app-exposed-map-control>
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-0 mt-3">
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameTrue" [value]="true">
            <label for="provideRoadNumberAndNameTrue">
              Chcę wprowadzić numer i nazwę drogi
            </label>
          </div>
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameFalse" [value]="false">
            <label for="provideRoadNumberAndNameFalse">
              Chcę wprowadzić ulicę
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            (change)="form.cityChange()"
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @if (form.provideRoadNumberAndName.value) {
              @for (item of townWithRoadsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            } @else {
              @for (item of townWithStreetsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.roadNumber) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"roadNumber" as controlName'>
            <label [for]='controlName'>
              Numer drogi *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="roadNumberChange(form.getElement($event).value)"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of getRoadList(form.city.value); track $index) {
                <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.roadName) {
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"roadName" as controlName'>
            <label [for]='controlName'>
              Nazwa drogi *
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę drogi'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.street) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of getStreetList(form.city.value); track $index) {
                <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                </option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
  </fieldset>
  <fieldset>
    <legend>
      Działki
    </legend>
    <div class="row">
      <div class="col-12">
        <app-parcels-crud formControlName="parcels"></app-parcels-crud>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend>
      Powierzchnie zajęcia
    </legend>
    <div class="row">
      <div class="col-12">
        <app-alert alertTitle="Uwaga!" type="info" [closable]="false">
          Wypełnij min <strong>1</strong> z poniższych sekcji.
        </app-alert>
      </div>
    </div>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"roadArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia jezdni (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię jezdni'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"sidewalkArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia chodnika (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię chodnika'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"bikePathArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia ścieżki rowerowej (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię chodnika'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"roadsideArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia rowu przydrożnego (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię rowu przydrożnego'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"greeneryArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia trawnika (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię trawnika'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"shoulderArea" as controlName'>
          <label [for]='controlName'>
            Powierzchnia pobocza (m<sup>2</sup>)
          </label>
          <input
            mask='separator.2'
            decimalMarker=','
            [dropSpecialCharacters]='false'
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu powierzchnię pobocza'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
</form>
